export default __webpack_public_path__ + "static/media/Online-red.c0cb4564.svg";